import { useQuery } from "react-query";

import { UsersService } from "~/entity/Users/api/service";

// Плоский список активных сотрудников ДЦ: GET /dealer/employees?dealerId= (PASDILER-2096)
export const useGetDealerEmployees = (dealerId?: string | number) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["getDealerEmployees", dealerId],
    queryFn: () => UsersService.GET.getDealerEmployees(dealerId),
    refetchOnWindowFocus: false,
    enabled: Boolean(dealerId),
  });

  return { data: data?.data, isLoading, isError, refetch };
};
